module.exports = __webpack_public_path__ + "static/construction-7403a7201d9c00af67662b7a66173f93.png";